import ContextMenu from './context-menu.vue'
export default ContextMenu
